
//Import React Hooks
import { useEffect, useState } from 'react'

//MUI
import Popover from '@mui/material/Popover';

//Import created components
import CreneauPopover from '../../components/creneaupopover/CreneauPopover.jsx'
import CreneauRider from '../../components/creneaurider/CreneauRider.jsx'

//Utils 
import convertHoraire from '../../utils/convert_horaire.js';
import elevesSorter from '../../utils/eleves_sorter.js';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getSelectedCreneaux, getEleves, getResa } from "../../store/selectors.js";
import { selectedCreneauxSlice } from "../../store/selectedCreneauxSlice.js";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { formLabelClasses, getCardHeaderUtilityClass } from '@mui/material';
const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)

function Creneau({ creneau }) {

    let riderList = []; //list of rider/eleve ids for this creneau
    // boolean : is today later than the creneau date?
    let pasTropTard = dayjs().isBefore(dayjs(creneau.date)) || dayjs().isSame(dayjs(creneau.date), 'day'); // si current day <= date creneau

    // if editResa Mode :
    let allResaInfos = useSelector(getResa);
    let modifMode = false;
    let historicCreneau = false;
    if (allResaInfos.CreneauEleves) {
        modifMode = allResaInfos.CreneauEleves.length > 0;
        //console.log(creneau);
        allResaInfos.CreneauEleves.map((creno) => {
            if (creneau.id_creneau === creno.creneau_id) { historicCreneau = true; /* console.log("creneau historic", creneau.date, creneau.horaire); */ }
        })
    }

    //// ----- popover management
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        if (pasTropTard === false || modifMode === true) { return } // make previuos days inactive
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {

        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'popover-creneau' : undefined;
    //// -- end of popover mgmt


    let elevesList = useSelector(getEleves);
    let selectedCreneaux = useSelector(getSelectedCreneaux);
    // find / filter if the current creneau is one of selected creneaux?
    let currentCreneau = selectedCreneaux.filter((ligne) => ligne.creneau.id_creneau === creneau.id_creneau);

    if (currentCreneau.length > 0) { // if this creneau is selected :
        modifMode = false; // we allow the click

        // we sort by id the eleves attending this creneau
        //riderList = currentCreneau[0].eleves.toSorted((e1, e2) => (e1.id < e2.id) ? -1 : (e1.id > e2.id) ? 1 : 0);
        riderList = elevesSorter(currentCreneau[0].eleves);

        let newList = [];
        //riderList = riderList.filter((eleve) => elevesList.find((e) => e.id === eleve.id).checked === true);
        riderList.map((rider) => { //recreate logic of line beyond, but managing eleves presents then unchecked 
            let riderPresent = elevesList.filter((e) => e.id === rider.id);
            if (riderPresent.length > 0) {
                if (riderPresent[0].checked === true) {
                    newList.push(riderPresent[0]);
                }
            }
        });
        riderList = newList; //get list of riders attending this creneaux, filtered by eleves, actually checked

    }

    const dispatch = useDispatch();
    function horairesCreneau() {
        let start = creneau.horaire; //start of creneau as float

        let end = creneau.horaire + creneau.duree; //end of creneau as float

        // return start and end as string (hh:mm) : 
        return [convertHoraire(start, "horaire"), convertHoraire(end, "horaire")];
    }

    function getHeaderClass() {
        let laClasse = "creneau-header-infos";
        laClasse += riderList.length > 0 ? " creneau-header-infos-selected" : historicCreneau === true ? " creneau-header-infos-historic" : " ";
        return laClasse;
    }



    return (
        <div className="creneau">
            <div className={pasTropTard === true ? modifMode === true ? "creneau-header creneau-header-modif-mode" : "creneau-header" : "creneau-header creneau-header-passe"} onClick={handleClick}>

                <div className={getHeaderClass()}>
                    <p className="creneau-header-infos-debut">{horairesCreneau()[0]}</p>
                    <p className={riderList.length > 0 ? "creneau-header-infos creneau-header-infos-fin-selected" : "creneau-header-infos-fin"}>-</p>
                    <p className={riderList.length > 0 ? "creneau-header-infos creneau-header-infos-fin-selected" : "creneau-header-infos-fin"}>{horairesCreneau()[1]}</p>
                </div>

            </div>

            {riderList.length > 0 ?
                <div className="creneau-eleves" onClick={handleClick}>
                    {riderList.map((eleve, index) => (<CreneauRider key={index} idEleve={eleve.id} />))}
                </div>
                :
                null
            }


            <Popover
                className="creneau-popover-root"
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <CreneauPopover creneau={creneau} setAnchorEl={setAnchorEl} mode={"creneau"} />
            </Popover>

        </div>
    );
}

export default Creneau;